import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { setRangesForAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/setRangesForAttributeModelData';

export const useUpdateAttribute = () => {
  const diagram = useDiagram();

  return React.useCallback(
    ({
      attributeIri,
      datatypes,
      newLabel,
    }: {
      attributeIri: string;
      datatypes: string[];
      newLabel?: string;
    }) => {
      if (!diagram) {
        return;
      }

      commitDiagramModel(diagram, (model) => {
        setRangesForAttributeModelData(attributeIri, datatypes)(model);
        if (newLabel) {
          setLabelForIri(attributeIri, newLabel)(model);
        }
      });
    },
    [diagram]
  );
};
